
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mixin as Clickaway } from 'vue-clickaway';
import { SweetModal } from 'sweet-modal-vue';
import axiosInstance from '../../../helpers/axios';
import stores from '../../../stores';
import session from '@/stores/Session';

@Component({
  components: {SweetModal},
  mixins: [ Clickaway ],
})
export default class EditProfile extends Vue { // DEPRECATED
  @Prop()
    profile!: IProfile;

  localProfile: IProfile | null = null;

  /**
   * Wathces for the changes when the edit popup is shown
   */
  @Watch('profile', {immediate: true})
    setModuleFromProps() {
      this.localProfile = JSON.parse(JSON.stringify(this.profile));
  }

  /**
   * Returns the header for the selected project
   */
  getHeaders() {
    return stores.File.getHeader();
  }

  /**
   * Emits openFileSys, then closes the popup
   */
  openFolderSys() {
    this.$emit('openFileSys');
    // @ts-ignore
    this.$children[0].close();
  }

  /**
   * Attaches the image to the profile, then calls save
   */
  sendReload(files: any, result: any) {
    if (this.localProfile) {
      this.localProfile.imageId = result.id;
      this.save();
    }
  }

  /**
   * Returns the root path for media
   */
  getFilePath(): string {
    return axiosInstance.defaults.baseURL + '/' + stores.File.uploadUrl();
  }

  /**
   * Removes the specified profile
   */
  removeProfile() {
    this.$emit('delete', this.localProfile);
  }

  /**
   * Emits save with the modified data
   */
  save(): void {
     this.$emit('save', this.localProfile);
  }

  /**
   * Closes the edit popup
   */
  cancel(): void {
    // @ts-ignore
    this.$children[0].close();
  }
}
